export const updateUser = (payload) => ({
    type: 'UPDATE_USER',
    payload
})
